import { render, staticRenderFns } from "./UserAttributesFilter.vue?vue&type=template&id=e52b4a64&scoped=true&"
import script from "./UserAttributesFilter.vue?vue&type=script&lang=js&"
export * from "./UserAttributesFilter.vue?vue&type=script&lang=js&"
import style0 from "./UserAttributesFilter.vue?vue&type=style&index=0&id=e52b4a64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52b4a64",
  null
  
)

export default component.exports